

<app-toolbar></app-toolbar>

<section class="bg-white mt-2 sticky-top">
    <div class="p-2">
        <div class="d-flex align-items-center">
            <button class="flex-shrink-1 align-self-start" mat-button type="button" (click)="backToPreviousPage()">
                <mat-icon>arrow_back</mat-icon>
                <span class="mr-2">Go Back</span>
            </button>
            <div class="flex-shrink-1">
                <img id="serviceLogo" [src]="serviceImagePath" (error)="serviceImagePath = 'assets/img/service-default.png'" class="mx-4" style="width: 100px;"/>
            </div>
            <div class="w-100 custom-primary">
                <p class="h5" style="font-weight: 400;">{{codeTypes[serviceItemObj?.code_type]?.name}}-{{serviceItemObj?.cpt_code}}</p>
                <p class="h4">{{serviceItemObj?.test_name}}</p>
            </div>
        </div>
    </div>
</section>

<div class="container-fluid">
    <div class="row">
        <div class="col-md-12" *ngIf="pRes">
            <mat-card class="my-1 mat-elevation-z2">
                <mat-card-content>
                    <ng-container *ngIf="testPricesList.length > 0; else noTestPrices ">
                        <div>
                            <table id="headTable" class="w-100">
                                <tr>
                                  <th>Type</th>
                                  <th>Gross Price</th>
                                  <th>Cash Price</th>
                                  <th>Min Price</th>
                                  <th>Max Price</th>
                                </tr>
                                <tr>
                                  <td>IP Price</td>
                                  <td>{{serviceItemObj?.std_price_ip ? (serviceItemObj?.std_price_ip | currency:'USD') : 'N/A'}}</td>
                                  <td>{{serviceItemObj?.cash_price_ip ? (serviceItemObj?.cash_price_ip | currency:'USD') : 'N/A'}}</td>
                                  <td>{{serviceItemObj?.min_price_ip ? (serviceItemObj?.min_price_ip | currency:'USD') : 'N/A'}}</td>
                                  <td>{{serviceItemObj?.max_price_ip ? (serviceItemObj?.max_price_ip | currency:'USD') : 'N/A'}}</td>
                                </tr>
                                <tr>
                                  <td>OP Price</td>
                                  <td>{{serviceItemObj?.std_price_op ? (serviceItemObj?.std_price_op | currency:'USD') : 'N/A'}}</td>
                                  <td>{{serviceItemObj?.cash_price_op ? (serviceItemObj?.cash_price_op | currency:'USD') : 'N/A'}}</td>
                                  <td>{{serviceItemObj?.min_price_op ? (serviceItemObj?.min_price_op | currency:'USD') : 'N/A'}}</td>
                                  <td>{{serviceItemObj?.max_price_op ? (serviceItemObj?.max_price_op | currency:'USD') : 'N/A'}}</td>
                                </tr>
                            </table>
                        </div>
                    </ng-container>
                    <ng-template #noTestPrices>
                        <div class="d-flex flex-column justify-content-center align-items-center w-100">
                            <img class="" src="assets/img/Prices-not-Available.svg" alt="">
                            <p class="h3 mt-4">No Prices Found</p>
                        </div>
                    </ng-template>
                </mat-card-content>
            </mat-card>
        </div>
        <ng-container *ngIf="ipRes">
            <ng-container *ngIf="pricesAvailable; else noInsurnacePrices">
                <div class="col-md-12" >
                    <div class="w-100 custom-primary">
                        <p class="h2 mt-3">Insurance Prices</p>
                    </div>
                </div>
                <div class="col-md-5 pr-1">
                    <mat-card class="mat-elevation-z2 my-1">
                        <mat-card-content>
                            <ng-container >
                                <div>
                                    <p-table #dt styleClass="p-datatable-gridlines" [value]="insurancePricesList"
                                        [paginator]="true" [rows]="10" paginatorPosition="both" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                                        <ng-template pTemplate="caption">
                                            <div *ngIf="toggler">
                                                <p-multiSelect [options]="filterColumns" [(ngModel)]="selectedColumns" optionLabel="carrier_name"
                                                    selectedItemsLabel="{0} Column(s) Selected" [style]="{minWidth: '200px', maxWidth: '300px'}" defaultLabel="Choose columns">
                                                </p-multiSelect>
                                            </div>
                                            <div *ngIf="!toggler">
                                                <p-multiSelect [options]="filterColumns" [(ngModel)]="selectedColumns" optionLabel="carrier_name"
                                                    selectedItemsLabel="{0} Column(s) Selected" [style]="{minWidth: '200px', maxWidth: '300px'}" defaultLabel="Choose columns">
                                                </p-multiSelect>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>Insurance Name</th>
                                                <th style="width: 120px">IP Price</th>
                                                <th style="width: 120px;">OP Price</th>
                                                <th style="width: 80px;">Options</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-element>
                                            <tr>
                                                <td>{{element?.carrier_name}}</td>
                                                <td>{{ element?.ip_price ? (element?.ip_price | currency:'USD') : 'N/A' }}</td>
                                                <td>{{ element?.op_price ? (element?.op_price | currency:'USD') : 'N/A' }}</td>
                                                <td>
                                                    <button [hidden]="!element.carrier_id" mat-icon-button [matMenuTriggerFor]="menu" class="text-muted">
                                                        <mat-icon>more_vert</mat-icon>
                                                    </button>
                                                    <mat-menu #menu="matMenu">
                                                        <button mat-menu-item (click)="openInsurancePricesDialog(element)">Edit</button>
                                                        <!-- <button mat-menu-item>Delete</button> -->
                                                    </mat-menu>
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </ng-container>
                        </mat-card-content>
                    </mat-card>
                </div>
                <div class="col-md-7 pl-1">
                    <ng-container >
                        <mat-card class="mat-elevation-z2 my-1">
                            <mat-card-content>
                                <div echarts [options]="chartOption"></div>
                            </mat-card-content>
                        </mat-card>
                    </ng-container>
                </div>
            </ng-container>
            <ng-template #noInsurnacePrices>
                <div class="d-flex flex-column justify-content-center align-items-center w-100">
                    <img class="" src="assets/img/Insurance-Price-not-available.svg" alt="">
                    <p class="h3 mt-4">Insurance Prices Not Found</p>
                </div>
            </ng-template>
        </ng-container>
    </div>
</div>
